import React from 'react';
import { Button as MuiButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslate } from 'ra-core';
import PropTypes from 'prop-types';
import { breakpoints } from '@/themes/themeOverrides/Breakpoints';

const StyledButton = styled(MuiButton)({
    '&.MuiButton-sizeSmall': {
        lineHeight: 1.5,
    },
    '&.no-label-mobile': {
        padding: '10px 16px',
        [`@media (max-width: ${breakpoints.values.md}px)`]: {
            minWidth: '44px',
            width: '44px',
            '& .MuiButton-endIcon': {
                margin: 0,
            },
            '& .button-label': {
                display: 'none',
            },
        },
    },
});

const getLinkParams = locationDescriptor => {
    if (locationDescriptor == undefined) {
        return undefined;
    }

    if (typeof locationDescriptor === 'string') {
        return { to: locationDescriptor };
    }

    const { redirect, replace, state, ...to } = locationDescriptor;
    return {
        to,
        redirect,
        replace,
        state,
    };
};

export const CustomButton = props => {
    const {
        alignIcon = 'left',
        children,
        className,
        disabled,
        label,
        color = 'primary',
        size = 'small',
        variant = 'contained',
        to: locationDescriptor,
        noLabelOnMobile,
        startIcon,
        endIcon,
        ...rest
    } = props;

    const translate = useTranslate();
    const translatedLabel = label ? translate(label, { _: label }) : undefined;
    const linkParams = getLinkParams(locationDescriptor);

    return (
        <StyledButton
            className={`${className} ${noLabelOnMobile ? 'no-label-mobile' : ''}`}
            color={color}
            size={size}
            variant={variant}
            aria-label={translatedLabel}
            disabled={disabled}
            startIcon={alignIcon === 'left' && children ? children : startIcon}
            endIcon={alignIcon === 'right' && children ? children : endIcon}
            {...linkParams}
            {...rest}
        >
            <span className='button-label'>{translatedLabel}</span>
        </StyledButton>
    );
};

CustomButton.propTypes = {
    alignIcon: PropTypes.oneOf(['left', 'right']),
    children: PropTypes.element,
    className: PropTypes.string,
    color: PropTypes.oneOfType([PropTypes.oneOf(['inherit', 'default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes.string]),
    disabled: PropTypes.bool,
    noLabelOnMobile: PropTypes.bool,
    label: PropTypes.string,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    variant: PropTypes.oneOf(['text', 'outlined', 'contained']),
    to: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            pathname: PropTypes.string,
            search: PropTypes.string,
            hash: PropTypes.string,
            state: PropTypes.any,
            redirect: PropTypes.bool,
            replace: PropTypes.bool,
        }),
    ]),
    component: PropTypes.elementType,
};
